import { useContext, useEffect, useState } from 'react';
import { EmailFolderInfo, PageWrapper } from '../../Types/MailT';
import { MailS } from '../MailS';
import { MessageDTO } from '../../Types/MessageT';
import { ProfileContext } from '../Context/ProfileContext';

// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-unused-vars
export const useImapFolderMessages = (openedFolder?: EmailFolderInfo) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [loading, setLoading] = useState(false);
  const [trigger, setTrigger] = useState<number>();
  const { unreadMessagesProps } = useContext(ProfileContext);
  const [changingSeenFlag, setChangingSeenFlag] = useState(false);
  const [query, updateQuery] = useState<string>();
  const [page, setPage] = useState<PageWrapper | null>();
  const [openedMessage, openMessage] = useState<MessageDTO>();
  const [loadingMessage, setLoadingMessage] = useState(false);
  const { increment, decrement } = unreadMessagesProps;

  useEffect(() => {
    if (openedFolder) {
      const { configId, fullName } = openedFolder;
      if (configId && fullName) {
        setLoading(true);
        MailS.getMessagesIMAP({
          folderName: fullName,
          pageNumber,
          configId,
          query,
        })
          .then(setPage)
          .finally(() => setLoading(false));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, pageNumber, query]);

  useEffect(() => {
    if (openedFolder) {
      if (pageNumber === 0) {
        refresh();
      } else {
        setPageNumber(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openedFolder]);

  const refresh = () => setTrigger(Date.now());
  const { pages, count, messages } = page ?? { pages: 0, count: 0, messages: [] };

  const selectMessage = (msg?: MessageDTO) => {
    if (msg) {
      openMessage(msg);
      loadFullMessage(msg.id);
    } else {
      openMessage(undefined);
    }
  };

  const loadFullMessage = async (id: number) => {
    const { configId, fullName } = openedFolder ?? {};
    if (configId && fullName) {
      setLoadingMessage(true);
      const fullMessage = await MailS.getMessageIMAP(id, configId, fullName);
      setLoadingMessage(false);
      if (fullMessage) {
        openMessage(fullMessage);
      }
    }
  };

  const changeSeenFlag = async (read: boolean) => {
    if (openedMessage) {
      setChangingSeenFlag(true);
      const { id, imap, fullNameFolder, outboundConfigId } = openedMessage;
      if (imap && fullNameFolder && outboundConfigId) {
        const ok = await MailS.changeMessageSeenFlagIMAP(id, outboundConfigId, fullNameFolder, read);
        if (ok) {
          updateMessage({ ...openedMessage, readTimestamp: read ? new Date() : null });
          if (read) {
            decrement();
          } else {
            increment();
          }
        }
      }
      setChangingSeenFlag(false);
    }
  };

  const updateMessage = (msg: MessageDTO) => {
    openMessage(msg);
    if (page) {
      const { messages } = page;
      const tmp = messages.map((m) => (m.id === msg.id ? msg : m));
      setPage({ ...page, messages: tmp });
    }
  };

  return {
    loading,
    setPageNumber,
    changeSeenFlag,
    changingSeenFlag,
    pageNumber,
    totalCount: count,
    pageCount: pages,
    count,
    messages,
    refresh,
    selectMessage,
    selectedMessage: openedMessage,
    loadingMessage,
    searchQuery: query,
    updateQuery,
  };
};
